import { NotFoundError } from "@/features/errors/not-found-error";

export const Route = createFileRoute({
  component: NotFoundError,
});
